import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

const chartThemePalette = {
  light: {
    fill: "rgba(17, 76, 95, 0.16)",
    border: "#114c5f",
    point: "#0f766e",
    text: "#16202b",
    muted: "#5a6774",
    grid: "rgba(22, 32, 43, 0.12)",
  },
  dark: {
    fill: "rgba(107, 216, 194, 0.16)",
    border: "#6bd8c2",
    point: "#9ae6da",
    text: "#e7eef6",
    muted: "#a7b6c6",
    grid: "rgba(216, 230, 242, 0.16)",
  },
};

const skillAreas = [
  {
    label: "Frontend Engineering",
    value: 95,
    description:
      "React, TypeScript, accessibility (a11y), responsive design, state management, component architecture, design systems, performance optimization",
  },
  {
    label: "Backend Engineering",
    value: 40,
    description:
      "Node.js, Express.js, REST APIs",
  },
  {
    label: "Agentic Engineering",
    value: 70,
    description:
      "AI-assisted development, Orchestration, MCP, Prompt Engineering",
  },
  {
    label: "DevOps & CI/CD",
    value: 50,
    description: "CI/CD pipelines, GitHub Actions, deployment automation",
  },
  {
    label: "Cloud & Infrastructure",
    value: 80,
    description: "Google Cloud Platform, Firebase, Salesforce",
  },
  {
    label: "Data Science & AI/ML",
    value: 60,
    description: "Machine learning, Neural Networks, NLP, LLMs, Data Collection & Cleaning",
  },
  {
    label: "Testing & Quality",
    value: 50,
    description:
      "Unit Testing, Code Review, Integration Testing, E2E, Testing Automation",
  },
];

const RadarChart = ({ theme = "light" }) => {
  const palette = chartThemePalette[theme] || chartThemePalette.light;
  const data = {
    labels: [
      "Frontend Engineering",
      "Backend Engineering",
      "Agentic Development",
      "DevOps & CI/CD",
      "Cloud & Infrastructure",
      "Data Science & AI/ML",
      "Testing & Quality",
    ],
    datasets: [
      {
        data: skillAreas.map((item) => item.value),
        backgroundColor: palette.fill,
        borderColor: palette.border,
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 4,
        pointBackgroundColor: palette.point,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: {
            size: 14,
          },
        },
      },
    },
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 100,
        angleLines: {
          color: palette.grid,
        },
        grid: {
          color: palette.grid,
        },
        pointLabels: {
          color: palette.text,
          font: {
            family: "IBM Plex Mono",
            size: 12,
          },
        },
        ticks: {
          color: palette.muted,
          backdropColor: "transparent",
          font: {
            family: "IBM Plex Mono",
            size: 10,
          },
        },
      },
    },
  };

  return (
    <div>
      <div
        className="radar-stats"
        role="img"
        aria-label="Radar chart summarizing Dario Cruz's skill areas across frontend, backend, DevOps, Salesforce, data science and AI, Firebase, and QA and testing."
      >
        <Radar data={data} options={options} />
      </div>
      <div className="skills-explanation">
        <h3>Domain Definitions</h3>

        <ul>
          {skillAreas.map((item) => (
            <li key={item.label}>
              <strong>{item.label}:</strong> {item.description}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RadarChart;
